export const setSettings = settings => {
  return {
    type: 'SET_PAGE_SETTINGS',
    settings: settings
  };
}

export const unsetSettings = () => {
  return {
    type: 'USET_PAGE_SETTINGS',
  };
}


// WEBPACK FOOTER //
// ./src/actions/settings.js